import { parsePersistedAuthTokens, type StampedTokens } from "@njbsoft/store";
import { COMPANY_STORE_PERSIST_KEY } from "@/store";

/**
 * The company portal's binding to the shared session parser. The parse itself
 * lives in `@njbsoft/store` beside the guarded persist storage that writes the
 * bag — one reader and one writer of one shape, so a stamp added on one side
 * cannot go unread on the other. Null for anything less than a live session: no
 * bag, an unparseable bag, or a bag whose tokens a sign-out cleared.
 */
export function parsePersistedSessionTokens(raw: string | null): StampedTokens | null {
  return parsePersistedAuthTokens(raw);
}

/** The persisted stamped pair straight from localStorage — what the refresh
 *  manager consults inside the cross-tab lock. */
export function readPersistedSessionTokens(): StampedTokens | null {
  return parsePersistedAuthTokens(window.localStorage.getItem(COMPANY_STORE_PERSIST_KEY));
}
